export default "__VITE_ASSET__CVtejhQa__"